
import React, { useEffect, useState } from "react";
import {
	Button,
	Stack,
	Box,
	Typography,
	Card,
	CardContent,
	Chip,
	TextField,
	InputAdornment,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	IconButton,
	Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { GlobalState } from "context/GlobalContext";
import { AuthState } from "context/AuthContext";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import { useNavigate } from "react-router-dom";
import { Discount_Master_Brands, DISOUNT_MASTER_CHANNEL_OPTIONS } from "./data";
import { Roles } from "data/authData";


export const roleAccess = (user) =>{

    let brandList = []
    let channelList = []
    let roles = "VIEWER"

    const brands = Discount_Master_Brands.map((store) => store.key)
    const channels = DISOUNT_MASTER_CHANNEL_OPTIONS.map((channel) => channel.key)
    const roleList = Roles.map((channel) => channel.key)

    if (user?.role?.["ADMIN"]) {
		roles = "ADMIN";
        brandList = brands
        channelList = channels
	}
    else{
        Object.keys(user?.role).forEach((role) => {
            if (role === "RARE_RABBIT") {
                brandList.push("RARE RABBIT");
            }
            if (role === "RAREONES") {
                brandList.push("RARE ONES");
            }
            if (brands.includes(role)){
                brandList.push(role)
            }
            if (channels.includes(role)){
                channelList.push(role)
            }
            if (roleList.includes(role)){
                roles = role
            }
        })
    }
	return {brandList, channelList, roles};
}
export const formatSchemeText = (template, buy, get) => {
        let i = 0;

        return template
            // Replace "Certain" with buy/get
            .replace(/Certain/g, () => (i++ === 0 ? buy : get))

            // Remove Value, Qty, Amount
            .replace(/\b(Value|Qty|Amount)\b/g, "")

            // Clean extra spaces
            .replace(/\s+/g, " ")
            .trim();
        };

export const generateSchemeStr = (data, scheme) =>{
        let compiledStr = []		
        const str = scheme?.replaceAll("_", " ") || ''
        data.forEach((element) => {
            if(scheme === "Flat_Discount_%"){
                compiledStr.push(`Flat ${element.percent}%  Discount`)
            }
            else if(scheme === "Flat_Discount_Value"){
                compiledStr.push(`Flat ${element.value} Off`)
            }
            else{
                compiledStr.push(formatSchemeText(str, element.buy, element.get))
            }
        })
        return compiledStr.join(" , ")
    }
export const getSchemeStatus = (data) => {
		// Check if published first
		const isPublished = data?.status === 'Published';

		if (!data?.start_date || !data?.end_date) return { label: 'Unknown', color: '#9e9e9e', bgColor: '#f5f5f5' };

		const now = new Date();
		const startDate = new Date(data.start_date);
		const endDate = new Date(data.end_date);

		// If not published, show Submitted status
		if (!isPublished &&  data?.status === 'Draft') {
			return { label: 'Draft', color: '#616161', bgColor: '#f5f5f5' };
		}
		if (!isPublished &&  data?.status === 'Submitted') {
			return { label: 'Submitted', color: '#e65100', bgColor: '#fff3e0' };
		}

		// If published, check date status
		if (now < startDate) {
			return { label: 'Upcoming', color: '#1976d2', bgColor: '#e3f2fd' };
		} else if (now > endDate) {
			return { label: 'Expired', color: '#d32f2f', bgColor: '#ffebee' };
		} else {
			return { label: 'Active', color: '#388e3c', bgColor: '#e8f5e9' };
		}
	};
export default function DiscountMasterList({ data = [] }) {
	const [discountList, setDiscountList] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [filteredList, setFilteredList] = useState([]);
	const navigate = useNavigate();

	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { user } = AuthState();
    const roleData = roleAccess(user)

	// Get status color
	const getStatusColor = (status) => {
		const statusMap = {
			Submitted: { bg: "#fff3e0", color: "#e65100", label: "Submitted" },
			Published: { bg: "#e8f5e9", color: "#2e7d32", label: "Published" },
			Draft: { bg: "#f5f5f5", color: "#616161", label: "Draft" },
			Active: { bg: "#e8f5e9", color: "#2e7d32", label: "Active" },
			Expired: { bg: "#ffebee", color: "#c62828", label: "Expired" },
		};
		return statusMap[status] || { bg: "#f5f5f5", color: "#616161", label: status };
	};

	const handleRowClick = (row) => {
		if (row?.status !== "Draft" || roleData.roles === "VIEWER") {
			navigate(`/explore/discount_master/discount_summary`, {
				state: { data: row },
			});
			return;
		}
		navigate(`/explore/discount_master/create_discount`, {
			state: { data: row },
		});
	};

	const handleGetDiscountList = async () => {
		setLoadingOpen(true);
        let body = {
                    brand: roleData?.brandList,
                    channel: roleData?.channelList,
                };
        console.log("asdjbajksdbasdkbhasid", body)
		pythonVmInstance
			.post("/discount-master/get-discounts-list", body)
			.then((res) => {
				setLoadingOpen(false);
				const list = res?.data || [];
				setDiscountList(list);
				setFilteredList(list);
			})
			.catch((err) => {
				console.log("error", err);
				const message = err?.response?.data?.message;
				setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: message || "Unable to fetch discount list",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			});
	};

	// Filter by search term
	const handleSearch = (value) => {
		setSearchTerm(value);
		const filtered = discountList.filter(
			(item) =>
				item.scheme_name?.toLowerCase().includes(value.toLowerCase()) ||
				item.brand?.toLowerCase().includes(value.toLowerCase()) ||
				item.channel?.toLowerCase().includes(value.toLowerCase()) ||
				item.scheme_type?.toLowerCase().includes(value.toLowerCase())
		);
		setFilteredList(filtered);
	};

	useEffect(() => {
		handleGetDiscountList();
	}, []);

	return (
		<Box sx={{ p: 3, background: "#fafafa", minHeight: "100vh" }}>
			{/* Header Section */}
			<Box
				sx={{
					mb: 3,
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Box>
					<Typography
						sx={{
							fontSize: "28px",
							fontWeight: "700",
							color: "#212121",
							mb: 0.5,
						}}
					>
						Discount Schemes
					</Typography>
					<Typography sx={{ fontSize: "13px", color: "#666666" }}>
						Manage and create discount schemes for your channels
					</Typography>
				</Box>
				<Button
					variant="contained"
					onClick={() => navigate(`/explore/discount_master/create_discount`)}
					startIcon={<AddIcon />}
                    disabled = {roleData.roles === "VIEWER" ? true : false}
					sx={{
						background: "#212121",
						color: "#ffffff",
						fontWeight: "600",
						textTransform: "none",
						fontSize: "14px",
						padding: "10px 20px",
						borderRadius: "6px",
						"&:hover": {
							background: "#3a3a3a",
						},
					}}
				>
					New Discount
				</Button>
			</Box>

			{/* Search Bar */}
			<Box sx={{ mb: 3 }}>
				<TextField
					fullWidth
					placeholder="Search by scheme name, brand, channel..."
					value={searchTerm}
					onChange={(e) => handleSearch(e.target.value)}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<SearchIcon sx={{ color: "#999" }} />
							</InputAdornment>
						),
					}}
					sx={{
						"& .MuiOutlinedInput-root": {
							background: "#ffffff",
							borderRadius: "8px",
							fontSize: "14px",
							"&:hover fieldset": {
								borderColor: "#e0e0e0",
							},
						},
					}}
				/>
			</Box>

			{/* Stats Cards */}
			{filteredList.length > 0 && (
				<Box
					sx={{
						display: "grid",
						gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
						gap: 2,
						mb: 3,
					}}
				>
					<Card sx={{ boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
						<CardContent sx={{ p: 2 }}>
							<Typography sx={{ fontSize: "12px", color: "#999", mb: 0.5 }}>
								Total Schemes
							</Typography>
							<Typography sx={{ fontSize: "24px", fontWeight: "700", color: "#212121" }}>
								{filteredList.length}
							</Typography>
						</CardContent>
					</Card>
					<Card sx={{ boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
						<CardContent sx={{ p: 2 }}>
							<Typography sx={{ fontSize: "12px", color: "#999", mb: 0.5 }}>
								Submitted
							</Typography>
							<Typography sx={{ fontSize: "24px", fontWeight: "700", color: "#2e7d32" }}>
								{filteredList.filter((s) => s.status === "Submitted").length}
							</Typography>
						</CardContent>
					</Card>
					<Card sx={{ boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
						<CardContent sx={{ p: 2 }}>
							<Typography sx={{ fontSize: "12px", color: "#999", mb: 0.5 }}>
								Drafts
							</Typography>
							<Typography sx={{ fontSize: "24px", fontWeight: "700", color: "#f57c00" }}>
								{filteredList.filter((s) => s.status === "Draft").length}
							</Typography>
						</CardContent>
					</Card>
				</Box>
			)}

			{/* Table Section */}
			{filteredList.length > 0 ? (
				<TableContainer
					component={Paper}
					sx={{
						boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
						borderRadius: "8px",
						border: "1px solid #e0e0e0",
					}}
				>
					<Table>
						<TableHead>
							<TableRow sx={{ background: "#fafafa", borderBottom: "2px solid #e0e0e0" }}>
								<TableCell
									sx={{
										fontWeight: "700",
										color: "#212121",
										fontSize: "13px",
										padding: "16px",
										textAlign: "left",
									}}
								>
									Scheme Name
								</TableCell>
								<TableCell
									sx={{
										fontWeight: "700",
										color: "#212121",
										fontSize: "13px",
										padding: "16px",
										textAlign: "center",
									}}
								>
									Type
								</TableCell>
								<TableCell
									sx={{
										fontWeight: "700",
										color: "#212121",
										fontSize: "13px",
										padding: "16px",
										textAlign: "center",
									}}
								>
									Brand
								</TableCell>
								<TableCell
									sx={{
										fontWeight: "700",
										color: "#212121",
										fontSize: "13px",
										padding: "16px",
										textAlign: "center",
									}}
								>
									Channel
								</TableCell>
								<TableCell
									sx={{
										fontWeight: "700",
										color: "#212121",
										fontSize: "13px",
										padding: "16px",
										textAlign: "center",
									}}
								>
									Scheme Status
								</TableCell>
								<TableCell
									sx={{
										fontWeight: "700",
										color: "#212121",
										fontSize: "13px",
										padding: "16px",
										textAlign: "center",
									}}
								>
									Record Status
								</TableCell>
								<TableCell
									sx={{
										fontWeight: "700",
										color: "#212121",
										fontSize: "13px",
										padding: "16px",
										textAlign: "center",
									}}
								>
									Actions
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{filteredList.map((row, idx) => {
								const statusColor = getStatusColor(row.status);
								const schemeStatusColor = getSchemeStatus(row);
								return (
									<TableRow
										key={idx}
										sx={{
											"&:hover": {
												background: "#f9f9f9",
											},
											borderBottom: "1px solid #e0e0e0",
										}}
									>
										<TableCell
											sx={{
												fontSize: "13px",
												fontWeight: "600",
												color: "#212121",
												padding: "16px",
											}}
										>
											{row.scheme_name || "—"}
										</TableCell>
										<TableCell
											sx={{
												fontSize: "12px",
												color: "#666",
												padding: "16px",
												textAlign: "center",
											}}
										>
											{row.scheme_type?.replaceAll("_", " ") || "—"}
										</TableCell>
										<TableCell
											sx={{
												fontSize: "12px",
												color: "#666",
												padding: "16px",
												textAlign: "center",
											}}
										>
											{row.brand || "—"}
										</TableCell>
										<TableCell
											sx={{
												fontSize: "12px",
												color: "#666",
												padding: "16px",
												textAlign: "center",
											}}
										>
											{row.channel || "—"}
										</TableCell>
										<TableCell sx={{ padding: "16px", textAlign: "center" }}>
											<Chip
												label={schemeStatusColor.label}
												size="small"
												sx={{
													background: schemeStatusColor.bg,
													color: schemeStatusColor.color,
													fontWeight: "600",
													fontSize: "11px",
												}}
											/>
										</TableCell>
										<TableCell sx={{ padding: "16px", textAlign: "center" }}>
											<Chip
												label={statusColor.label}
												size="small"
												sx={{
													background: statusColor.bg,
													color: statusColor.color,
													fontWeight: "600",
													fontSize: "11px",
												}}
											/>
										</TableCell>
										<TableCell sx={{ padding: "16px", textAlign: "center" }}>
											{row.status !== "Draft" || roleData.roles === "VIEWER" ? (
												<Tooltip title="View Summary">
													<IconButton
														size="small"
														onClick={() => handleRowClick(row)}
														sx={{
															color: "#1976d2",
															"&:hover": { background: "#e3f2fd" },
														}}
													>
														<VisibilityIcon fontSize="small" />
													</IconButton>
												</Tooltip>
											) : (
												<Tooltip title="Edit">
													<IconButton
														size="small"
														onClick={() => handleRowClick(row)}
														sx={{
															color: "#212121",
															"&:hover": { background: "#f5f5f5" },
														}}
													>
														<EditIcon fontSize="small" />
													</IconButton>
												</Tooltip>
											)}
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<Card
					sx={{
						boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
						borderRadius: "8px",
						border: "1px solid #e0e0e0",
						textAlign: "center",
						p: 6,
					}}
				>
					<Typography sx={{ fontSize: "18px", fontWeight: "600", color: "#999", mb: 1 }}>
						No Discount Schemes Found
					</Typography>
					<Typography sx={{ fontSize: "13px", color: "#bbb" }}>
						{searchTerm ? "Try adjusting your search terms" : "Create a new discount scheme to get started"}
					</Typography>
				</Card>
			)}
		</Box>
	);
}